import { render, staticRenderFns } from "./OvbApp.vue?vue&type=template&id=288e3c2a&"
import script from "./OvbApp.vue?vue&type=script&lang=js&"
export * from "./OvbApp.vue?vue&type=script&lang=js&"
import style0 from "./OvbApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports